// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"162":"component---src-pages-terms-jsx","279":"component---src-pages-index-jsx","415":"component---src-pages-404-jsx","955":"component---src-pages-privacy-jsx"}[chunkId] + "-" + {"162":"c216b7f45121ca1010eb","279":"02ce5ffd4bcb5d981265","415":"54f039c61cee231404ed","955":"368e5b1dddbd012bb938"}[chunkId] + ".js";
};